import React, { useState } from 'react'
import { useParams } from 'react-router';
import BasicDetailSection from './BasicDetailSectin/BasicDetailSection';
import PropertyLocationForm from './LocationForm/PropertyLocationForm';

interface Option {
  key: string;
  value: string;
  description: string;
  icon: string;
}

interface PropertyTypeOption extends Option {}

interface Furnishings {
  status: string;
  features: {
    light: string;
    fans: string;
    ac: string;
    tv: string;
    geyser: string;
    beds: string;
    wardrobe: string;
    otherItems: string[];  // For additional items like Sofa, Washing Machine, etc.
  };
}

interface ParkingDetails {
  coveredParking: string;
  openParking: string;
}

interface PossessionDetails {
  expectedBy: string;
  month: string;
}

interface CapacityAvailability {
  totalBeds: string;
  features: string[];  // List of features (e.g., Wi-Fi, AC)
}

interface PricingAndOthers {
  rentDetails: {
    expectedRent: string;
    maintenance: string;
    maintenanceUnit: string;
    bookingAmount: string;
    membershipCharge: string;
    priceNegotiable: boolean;
    electricityWaterExclude: boolean;
  };
  securityDeposit: {
    type: string;
    depositValue: string;
    noOfMonths: string;
  };
  totalPriceIncludes: string[];
  OwnershipPriceDetails: Record<string, any>;
  PropertyFeatures: Record<string, any>;
}

interface BasicDetails {
  lookingTo: "Sell" | "Rent / Lease" | "PG";
  propertyType: "Residential" | "Commercial" | "agriculture";
  officeType?: PropertyTypeOption;
  retailSpaceType?: PropertyTypeOption;
  retailLocationInside?: PropertyTypeOption;
  plotLandType?: PropertyTypeOption;
  storageType?: PropertyTypeOption;
  industryType?: PropertyTypeOption;
  hospitalityType?: PropertyTypeOption;
  additionalOption?: PropertyTypeOption;
}

// Define the same types as used in the child component
interface Landmark {
  name: string;
  destination: { lat: number; lng: number } | null;
  distance: { meters: number; kilometers: string };
  selected: boolean;
}

interface LocationDetails {
  searchLocation: string;
  city: string;
  locality: string;
  subLocality: string;
  apartmentSociety: string;
  houseDetails: string;
  lat?: number;
  lng?: number;
  nearbyLandmarks: Landmark[];
}

interface AboutProperty {
  roomDetails: {
    bedrooms: string;
    bathrooms: string;
    balconies: string;
  };
  areaDetails: {
    carpetArea: string;
    carpetAreaUnit: "sq.ft";
    buildupArea: string;
    buildupAreaUnit: "sq.ft";
    superBuildUpArea: string;
    superBuildUpAreaUnit: "sq.ft";
    plotArea: string;
    plotAreaUnit: "sq.ft";
  };
  roadDetails: {
    roadWidth: string;
    roadWidthUnit: "sq.ft"; // Default unit for road width
  };
  propertyFacing: string;
  otherRooms: string[];
  furnishings: Furnishings;
  floorDetails: {
    totalFloor: string;
    propertyOnFloor: string;
  };
  parking: ParkingDetails;
  availabilityStatus: string;
  possessionBy: PossessionDetails;
  availableFrom: string;
  willingToRentOutTo: string[];
  suitableFor: {
    students: boolean;
    workingprofessionals: boolean;
  };
  RoomOccupancy: string;
  RoomType: string;
  capacityAvailability: CapacityAvailability;
  constructionDetails: {
    floorsAllowed: string;
  };
  availableFor: string;
  propertyDimensions: {
    length: string;
    breadth: string;
  };
  boundaryWallStatus: string;
  openSides: string;
  constructionDone: string;
  CornerProperty: boolean;
}

interface MediaFiles {
  mediaFiles: File[]; // Array for media files
}

interface FormData {
  basicDetails: BasicDetails;
  locationDetails: LocationDetails;
  // aboutProperty: AboutProperty;
  // mediaFiles: MediaFiles;
  // pricingAndOthers: PricingAndOthers;
}




const EditPropertyPage = () => {
  const { id } = useParams(); // Get the property ID from URL

  const [formData, setFormData] = useState<FormData>({

    basicDetails: {
      lookingTo: "Sell", // For "I'm Looking To"
      propertyType: "Residential", // For "What kind of property do you have?"
      officeType: {
        key: "",
        value: "",
        description: "",
        icon: ""
      },// New key for office type selection
      retailSpaceType: {
        key: "",
        value: "",
        description: "",
        icon: ""
      },
      retailLocationInside: {
        key: "",
        value: "",
        description: "",
        icon: ""
      },
      plotLandType: {
        key: "",
        value: "",
        description: "",
        icon: ""
      },
      storageType: {
        key: "",
        value: "",
        description: "",
        icon: ""
      },
      industryType: {
        key: "",
        value: "",
        description: "",
        icon: ""
      },
      hospitalityType: {
        key: "",
        value: "",
        description: "",
        icon: ""
      },
      additionalOption: {
        key: "",
        value: "",
        description: "",
        icon: ""
      },
    },

    locationDetails: {
      searchLocation: "",
      city: "",
      locality: "",
      subLocality: "",
      apartmentSociety: "",
      houseDetails: "",
      nearbyLandmarks: [],
  },
  });

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const { name, value } = e.target;
    const fields = name.split(".");

    setFormData((prevState) => {
      let updatedState = { ...prevState };
      let currentSection = updatedState;

      // Iterate through the fields (except the last one) and navigate through the object structure
      for (let i = 0; i < fields.length - 1; i++) {
        if (!currentSection[fields[i]]) {
          currentSection[fields[i]] = {};  // If the field doesn't exist, create it
        }
        currentSection = currentSection[fields[i]];  // Move deeper
      }

      // Update the last field with the new value
      currentSection[fields[fields.length - 1]] = value || "";

      return updatedState;
    });
  };




  return (
    <form className='space-y-6'>
      <BasicDetailSection formData={formData} setFormData={setFormData} handleChange={handleChange} />
      <PropertyLocationForm formData={formData} setFormData={setFormData}/>
    </form>
  )
}

export default EditPropertyPage